import type { FaireProductEntity } from "../../entity_types/product";

export const p_eu8eapydrv: FaireProductEntity = {
  token: "p_eu8eapydrv",
  type: "product",
  name: "Shampoo Bar For Volumizing and Thickening",
  brandToken: "b_4iyz6j79hv",
  brandName: "The Earthling Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/2982786fcef27c7d93aa59d9ecd214e8bb4d66e19b6c0ee593a68ddcf9586925.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9fdd0e44078224b01e47b1751a42942223023f57c217ea2501ec3b221afc443.jpeg",
    "https://cdn.faire.com/fastly/e217b8fc0f5903c053b2e165263960796d9a14608e4c38d5289ec538d70d1fcc.jpeg",
    "https://cdn.faire.com/fastly/81567e1d57c1cd88626959ac014432640221d47311a157acca7b2078bcaed3ba.jpeg",
    "https://cdn.faire.com/fastly/32f5563f22c06e132ef3ced19ad09d2a4c7e4c52b80e6de40ab29a952efecef0.jpeg",
    "https://cdn.faire.com/fastly/5eae2aeb6531c242748c39f1f7b6b5e0bae3ec43171487af4a44ae6eb040eba1.jpeg",
    "https://cdn.faire.com/fastly/a8d2a6d3ea80160933bf13b3399dbab0060a0ab169bbfd4bf367acf6f41a9ad3.jpeg",
    "https://cdn.faire.com/fastly/e03b5c799ece3f34ce009e42b02e384d6febbc64b8a2829e6ae3196b25e5572d.jpeg",
    "https://cdn.faire.com/fastly/ec3fe1990c7abf835927f191905c97745da674324a7652d3fe63be77e8acdee0.jpeg",
    "https://cdn.faire.com/fastly/cab4200142d71670595cbd387c6a66620b0eb4716ccb0b2cc6b4c163a37fb493.png",
    "https://cdn.faire.com/fastly/2c3b67badd175d14dd9dce3a9cdff8dc5d98f27c3a39f19906c40005d67796bb.png",
    "https://cdn.faire.com/fastly/a92be1f737596d8885e6c127195fcaa8905271e67d63f450187b98f5487d1c57.png",
    "https://cdn.faire.com/fastly/c88dc4195b5821220153ade9a53737e30d4133a38d6fdb8b5f9b7b737fdc7230.png",
    "https://cdn.faire.com/fastly/ba961fdfd6197dc0b4be1259b9e34807ee221858a2dcb3323298cd831538e538.png",
    "https://cdn.faire.com/fastly/6bde9ec58c94048defcbc93fbd3c4005f4282ea5c85da158e7787d375b0bbc74.png",
    "https://cdn.faire.com/fastly/19ca35ed0d6b505dd9d35db4042a0c4538d57666046e6b88489f733e40a74494.png",
  ],
  priceDollars: 11.07,
  description:
    "Unlock the best hair of your life with high-quality, intentional ingredients that nourish, protect, and enhance your natural shine.\n\nA Shampoo Bar with a quick-building, luxurious lather that works like bottled shampoo to effectively cleanse oil, dirt, and build-up without stripping your hair and scalp’s natural moisture. Made with a balanced formula of nourishing, naturally derived ingredients that increase volume, reduce breakage, and promote stronger strands – leaving you with new hair growth that’s bouncy, healthy, and shiny.\n\nOur formula was designed to work with all hair types (curly and color-treated, too!) and transform your hair health.\n\nA great gift for Mother's Day, sustainability and travel, and getting hair ready for summer! \n",
  tags: [],
  msrpDollars: 22.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:53.275Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
